import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import "./MemberList.css";
import MemberCard from "../MemberCard/MemberCard";
import MemberTable from "../MemberTable/MemberTable";
import { Grid, Typography } from "@mui/joy";

const MemberList = ({ members, search, display, tab }) => {
  const [displayMembers, setDisplayMembers] = useState(members);
  const [displayState, setDisplayState] = useState(display);

  useEffect(() => {
    setDisplayMembers(
      members.filter((member) => member.type.toLowerCase() === tab)
    );
    setDisplayState(display);

    if (search?.length > 0) {
      const displayMem = members.filter((member) => {
        return (
          (member.fullName.toLowerCase().includes(search.toLowerCase()) ||
            member.state.toLowerCase().includes(search.toLowerCase())) &&
          member.type.toLowerCase() === tab
        );
      });

      setDisplayMembers(displayMem);
    }
  }, [display, search, members, tab]);

  return (
    <>
      {displayMembers.length > 0 ? (
        displayState === "cards" ? (
          <Grid
            container
            spacing={{ xs: 2, sm: 3 }}
            columns={{ xs: 1, sm: 2, md: 3, lg: 4 }}
            sx={{ maxWidth: "1280px", width: "100%", paddingBottom: "40px" }}
          >
            {displayMembers?.map((member, index) => {
              return (
                <Grid key={index} xs={1} sx={{ display: "flex" }}>
                  <MemberCard member={member} key={index} />
                </Grid>
              );
            })}
          </Grid>
        ) : (
          <MemberTable members={displayMembers} />
        )
      ) : (
        <Typography
          level="body-sm"
          sx={{ maxWidth: "1280px", width: "100%", paddingBottom: "40px" }}
        >
          No representatives match this search
        </Typography>
      )}
    </>
  );
};

// Prop types for our Component
MemberList.propTypes = {
  members: PropTypes.array.isRequired,
  search: PropTypes.string,
  display: PropTypes.string,
};

export default MemberList;
